import React, { useState } from "react";
import { Container, makeStyles, Paper } from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import KmTabPanel from "src/components/common/KmTabPanel";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import VotingsFinishedView from "./VotingsFinishedView";
import VotingsInProgressView from "./VotingsInProgressView";
import VotingsCanceledView from "./VotingsCanceledView";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { userHasAtLeastOnePermission } from "src/utils/userutils";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3.5),
    marginBottom: theme.spacing(1),
    flexGrow: 1,
  },
  gridzerosp: {
    margin: 0,
    padding: 0,
  },
}));

const VotingsListView = ({
  globalData,
  enableGlobalLoader,
  disableGlobalLoader,
  ...rest
}) => {
  const classes = useStyles();

  const labelToTabs = {
    wtrakcie: 0,
    zakonczone: 1,
    anulowane: 2,
  };

  const { tabId, pageId, rowsCount } = useParams();
  const [value, setValue] = React.useState(
    labelToTabs[tabId] ? labelToTabs[tabId] : 0
  );

  const [rows, setRows] = useState([]);
  const [reloadCounter, setReloadCounter] = useState(0);
  const [removingNews, setRemovingNews] = useState(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  function a11yProps(index) {
    return {
      id: `scrollable-auto-tab-${index}`,
      "aria-controls": `scrollable-auto-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    let tab = Object.keys(labelToTabs).find(
      (key) => labelToTabs[key] === newValue
    );

    setValue(newValue);

    if (tab) {
      navigate(`/glosowania/${tab}`);
    } else {
      navigate("/glosowania");
    }
  };

  return (
    <Page className={classes.root} title="Głosowania">
      <KmPageTitle>Głosowania</KmPageTitle>
      <Container maxWidth={false}>
        <Paper>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="on"
              aria-label="Głosowania"
            >
              <Tab
                label="W trakcie"
                {...a11yProps(0)}
                aria-label="Głosowania w trakcie"
              />
              <Tab
                label="Zakończone"
                {...a11yProps(1)}
                aria-label="Głosowania w zakończone"
              />
              {userHasAtLeastOnePermission(globalData, [
                "user_admin",
                "super_admin",
              ]) ? (
                <Tab
                  label="Anulowane"
                  {...a11yProps(2)}
                  aria-label="Głosowania anulowane"
                />
              ) : (
                <></>
              )}
            </Tabs>
          </AppBar>
          <KmTabPanel value={value} index={0}>
            <VotingsInProgressView />
          </KmTabPanel>
          <KmTabPanel value={value} index={1}>
            <VotingsFinishedView />
          </KmTabPanel>
          {userHasAtLeastOnePermission(globalData, [
            "user_admin",
            "super_admin",
          ]) ? (
            <KmTabPanel value={value} index={2}>
              <VotingsCanceledView />
            </KmTabPanel>
          ) : (
            <></>
          )}
        </Paper>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
});

export default connect(mapStateToProps, mapDispatchToProps)(VotingsListView);
